import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, HyattEvent } from "../../../services/index";
import { JGRNService } from "../../../services/jgrn.service";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
@Component({
  selector: "addEditBitStock",
  templateUrl: "addEditBitStock.html",
})
export class addEditBitStock {
  type: any;
  row: any;
  data: any;
  isLoadMask: Promise<any>;
  designdata: any = { indent_no: 0, rcvd_type_name: "" };
  bitData: any = {
    ref_no: "",
    bit_date: "",
    total_bits: 0,
    total_mtrs: 0,
  };
  // fabStyleList = ["CHECKS","PLAIN","PRINT","PANEL","STRIPES"];
  varietyList = [];
  varietyList1 = [];
  widthList = [36,44,58];
  colorList: any;
  designInc : number;
  poList: any;
  invList: any;
  JGRNdata: any = {};
  mode: string;
  saveEvent: any;
  agentList: any;
  partyList: any;
  OdList: any;
  poNoList: any;
  design_no: any;
  lrList: any;
  LRList: any;
  design_auto_no: any;
  designList: any;
  isLoading: boolean = false;
  finyearList = [];
  designnoList: any;

  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];

    let bitData = Object.assign({}, val["data"]);
    this.bitData = bitData;
    this.bitData.total_bits = 0;
    this.bitData.total_mtrs = 0;
    if (this.mode == "Edit" || this.mode == "View") {
      this.loadeditJGRNList();
      // this.polist();
      //  this.getDesign(this.JGRNData.po_no);
      //    this.generateOdNo();

      // this.JGRNData.JGRN_date = this.formatDate(this.JGRNData.JGRN_date);

      // this.generateOdNo();
      // this.onEnterpono(this.JGRNData.po_no);
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("qualityAuto") qualityAuto;
  @ViewChild("typeAuto") typeAuto;

  constructor(
    public store: Store<fromRootStore.State>,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    public jgrn: JGRNService,
    public event: HyattEvent
  ) {
    this.bitData.total_bits = 0;
    this.bitData.total_mtrs = 0;
    this.row = {
      party_design: "",
      width: "",
      mtr: 0,
      fab_design: "",
      fab_style: "",
      color: ""
    };
    this.data = {
      jgrnList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.jgrnList.push(row);

    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

  }
  ngOnInit() {
    this.colorlist();
    this.getVarietyList();

    this.tableScroll();
    
    if (this.mode == "Add") {
      this.generateBitFabNo(0);
      this.bitData.bit_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.getAuto();
      
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#partydesign-0").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#" + nextEl).focus();
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      party_design = this.data.jgrnList[ind]["party_design"],
      width = this.data.jgrnList[ind]["width"],
      mtr = this.data.jgrnList[ind]["mtr"],
      fab_style = this.data.jgrnList[ind]["fab_style"],
      fab_design = this.data.jgrnList[ind]["fab_design"],
      color = this.data.jgrnList[ind]["color"];

    let nxtRow = $("#row-" + ind).next("tr");

    if ((fab_design != "") || color != "") {
      if (fld == "partydesign" && nxtRow.length == 0) {
        for (let i = 0; i < this.data.jgrnList.length; i++) {
          if (ind + 1 == this.data.jgrnList.length) {
            let rowdetail = Object.assign({}, this.row);

            this.data.jgrnList.push(rowdetail);

            nxtInd = this.data.jgrnList.length - 1;
           
          }
        }
      }
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  oncheckemptyrow() {
    let jgrn = this.data.jgrnList;
    let jgrnList = [];
    for (let i = 0; i < jgrn.length; i++) {
      if (jgrn[i].fab_design != "") {
        jgrnList.push(jgrn[i]);
      }
    }
    this.data.jgrnList = jgrnList;
    this.bitData.total_bits = this.data.jgrnList.length;
    this.onSaveBitStock();
  }
  tableScroll() {
    $(".invscreen").height(window.innerHeight - 495);
    $(".JGRNbody").width(window.innerWidth - 30);
  }
  onDeleteRow($event, fld, ind) {
    if (this.data.jgrnList.length > 1) {
      swal({
        title: "Are you sure to delete this bit stock?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No",
      }).then(() => {
        this.data.jgrnList.splice(ind, 1);

        if ($("#" + fld + "-" + (ind - 1)).length > 0) {
          $("#" + fld + "-" + (ind - 1)).focus();
        } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
          $("#" + fld + "-" + (ind + 1)).focus();
        }
        // this.designInc -= 1; 
        this.calcMtrs(ind);
      }).catch(() => {

      })
      
    }
    // this.calcTotal();
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.jgrn.getBitAuto({}).then((res: any) => {
      this.bitData.ref_no = res;
    });
  }

  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }


  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {

    let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
            if(!unique.some(obj => obj.variety === o.variety)) {
              unique.push(o);
            }
            return unique;
        },[]);
    
      this.varietyList1 =  this.varietyList;
     
    });
    
  }
  calcMtrs(ind) {
    let mtr = this.data.jgrnList[ind].mtr,
      tot_mtr = 0;
    for (let i = 0; i < this.data.jgrnList.length; i++) {
      let jgrndata = this.data.jgrnList[i];
      tot_mtr += jgrndata.mtr;
    }
    this.bitData.total_bits = this.data.jgrnList.length;
    this.bitData.total_mtrs = tot_mtr.toFixed(2);
  }

 
  generateBitFabNo(ind) {
    let params = {};
    let that = this;
    
   if(this.mode == 'Edit'){
     return 
   }
    that.jgrn.generateBitFabNo(params).then((res: any) => {
      if(ind == 0){
        if(that.data.jgrnList[ind].color != ''){
          that.designInc = res; 
          that.data.jgrnList[ind].fab_design = 'BT-' + that.designInc;
        }
          
      }else{
        let lastDes = Number(that.data.jgrnList[ind-1].fab_design.substr(3)) + 1;
        // that.designInc += 1; 
        that.data.jgrnList[ind].fab_design = 'BT-' + lastDes;
      }
       
    
    });
  }

  refnoGenearted(ind){
    if(ind == 0){
      if(this.bitData.ref_no <= 0 || this.bitData.ref_no == undefined){
        swal("Ref no not generated..Please go back and start entry again");
        return;
      }
    }
  }

  onSaveBitStock(): void {
    if (
      !(this.data.jgrnList.every(el => {
        return el.width != ''
      })) ||
       !(this.data.jgrnList.every(el => {
        return el.fab_style != ''
      })) ||
       !(this.data.jgrnList.every(el => {
        return el.mtr != ''
      })) ||
       !(this.data.jgrnList.every(el => {
        return el.fab_design != ''
      })) ||
       !(this.data.jgrnList.every(el => {
        return el.color != ''
      }))
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      let params: any = Object.assign({}, this.bitData);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data);
      params["bit_date"] = this.datePipe.transform(
        params["bit_date"],
        "yyyy-MM-dd"
      );
      let that = this;

      swal({
        title: "Are you sure to save this bit stock?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.jgrn
          .saveBitStock(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              // that.saveEvent.emit();
            }
            that.event.jgrnSavedSource.next("saved");
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              swal({
                title: "Click YES for Sticker Print?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes!",
                cancelButtonText: "No",
              }).then(() => {
                that.loadeditJGRNPrintList(res.jgrn_id);
              }).catch(() => {
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                  that.saveEvent.emit();
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              });
            
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  loadeditJGRNPrintList(jgrnid) {
    let params = {
      jgrn_id: jgrnid,
      stock_type : 'BIT'
    };
    let that = this;
    that.jgrn.getEditBitJGRNList(params).then((res: any) => {
      that.data.jgrnList = res.data;
      var row  = res.data[0];
      // that.calcTotal();
      // that.calcQty();
      if(row.jgrnType == 'BIT'){
        swal({
          title: "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          that.clickPrint(row, res.data);
        }).catch(() => {
          
        });
      }else{
        swal({
          title: "Please ensure that large Sticker roll (Bulk Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          that.clickPrint(row, res.data);
        }).catch(() => {
          
        });
      }

      
    }).catch(() => {
          
    });
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn.jgrnprint(params).then(function (res: any) {
      if (that.mode == "Add") {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
        that.saveEvent.emit();
      } else {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
      }
    }).catch(() => {
          
    });
  }

  loadeditJGRNList() {
    let params = {
      jgrn_id: this.bitData.jgrn_id,
      stock_type : 'BIT'
    };
    let that = this;
    that.jgrn.getEditBitJGRNList(params).then((res: any) => {
      that.data.jgrnList = res.data;
      that.bitData.bit_date = that.data.jgrnList[0]['jgrn_date'];
      that.bitData.ref_no = that.data.jgrnList[0]['bit_ref_no'];
      that.bitData.total_mtrs = that.data.jgrnList[0]['total_mtr'];
      that.bitData.total_bits = that.data.jgrnList[0]['total_bits'];
      // this.calcTotal();
      // this.calcQty();
    }).catch(() => {
          
    });
  }
}




// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitStock/addEditBitStock.ts